export default __webpack_public_path__ + "static/media/30t.c20b747e.jpg";